var _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7474,
    cy: 18.6708,
    rx: 18.1376,
    ry: 18.1376,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5019 25.8761L26.3076 20.7568H21.2675V17.4362C21.2675 16.0354 21.9702 14.669 24.2277 14.669H26.5206V10.3107C26.5206 10.3107 24.4406 9.96484 22.453 9.96484C18.3002 9.96484 15.5884 12.4172 15.5884 16.8551V20.7568H10.9741V25.8761H15.5884V38.2523C16.5148 38.3941 17.4625 38.4667 18.4279 38.4667C19.3934 38.4667 20.3411 38.3941 21.2675 38.2523V25.8761H25.5019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 18.7474,
    y1: 0.533203,
    x2: 18.7474,
    y2: 36.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b7e67363881c99becba6fdc7aade1000.svg";
export { ForwardRef as ReactComponent };